import venda from './venda';
import origens from './origens';
import motivosCancelamento from './motivosCancelamento';

export default {
  venda,
  origens,
  motivosCancelamento
}
